<template>
	<div class="tw-flex-col tw--mx-3">
		<div class="px-3 tw-pb-3">
			<c-title-header
				:title="selectedJob.name"
				@go-to-back="goTo(codeStep.returnTo)"></c-title-header>
		</div>
		<div class="tw-flex">
			<div class="px-3 tw-w-3/5">
				<model-stepper
					:current-step="7"
					class="tw-mb-4"
					@code-step="loadCodeStep">
				</model-stepper>
				<p-card class="tw-flex-auto tw-flex tw-flex-col tw-justify-between tw-my-">
					<div class="tw-flex tw-justify-between tw-item-center tw-mb-6">
						<p class="tw-text-app-color-primary text-lg">
							Agregar de 3 a 5 Destrezas mas importantes
						</p>
						<p-button
							type="primary"
							@click="choosenSkills">
							Agregar Destrezas
						</p-button>
					</div>
					<section class="competences">
						<div class="text-uppercase competences-header tw-px-6 tw-pr-32 tw-py-1 tw-flex tw-justify-between tw-mb-4">
							<span>NOMBRE DE COMPETENCIAS</span>
							<span>REQ.SELEC./CAP.</span>
						</div>
						<div class="competences-list tw-flex tw-flex-col tw-gap-6">
							<skill-item
								:skill="skill"
								v-for="(skill, index) in selectedSkills"
								:key="index"
								@closeClicked="handleRemoveSkillItem(skill)"
								@chooseLevelClicked="handleChooseLevelSkillItem(skill)"
							>
							</skill-item>
							<p-empty-message v-if="!selectedSkills.length">
								Escoge de 3 a 5 Destrezas<br>más importantes
							</p-empty-message>
						</div>
					</section>
					<div>
						<p-horizontal-divider />
						<div class="tw-text-center">
							<p-button
								type="primary"
								@click="goTo(codeStep.returnTo)"
							>
								Atrás
							</p-button>
							<p-button
								type="secondary"
								:disabled="validate || selectedSkills.length === 0 || selectedSkills.length < codeStep.minSkills || selectedSkills.length > codeStep.maxSkills"
								@click="saveStepFifth"
							>
								Siguiente
							</p-button>
							<p-button
								type="black"
								@click="goTo(codeStep.goTo)"
							>
								Omitir
							</p-button>
						</div>
					</div>
				</p-card>
			</div>
			<div class="px-3 tw-w-2/5">
				<model-description
					:title="'DESTREZAS REQUERIDAS'"
					:subtitle="'INSTRUCCIONES'">
					<div class="tw-my-4" slot="content">
						<p style="font-size: 13px;" class="tw-text-center">Agregar de 3 a 5 Destrezas requeridas y seleccionar nivel <b>(Destrezas: son comportamientos laborales automatizados por 
							la práctica en la ejecución de la actividad.)</b>
						</p>
						<div class="content-box">
							<table>
								<tr>
									<td style="width: 25%; vertical-align: top;"><p>Paso 1:</p></td>
									<td style="width: 75%">
										<span :style="`color:${$appColors.secondary}`">Escoger Destreza</span><br>
										<span><b>Analizar Operaciones</b></span>
									</td>
								</tr>
								<br>
								<tr>
									<td style="width: 25%; vertical-align: top;"><p>Paso 2:</p></td>
									<td style="width: 75%">
										<span :style="`color:${$appColors.secondary}`">Escoger Nivel</span><br>
										<span><b>Nivel Alto:</b></span><br>
										<span>(Identificar el sistema de control requerido por una nueva unidad organizacional)</span>
									</td>
								</tr>
							</table>
						</div>
						<div class="tw-flex tw-flex-col tw-items-center">
							<br>
							<p-button
								class="tw-my-4"
								type="primary"
							>
								Mira nuestro tutorial paso a paso
							</p-button>
						</div>
					</div>
				</model-description>
			</div>
		</div>
		<skill-selection-dialog
			ref="skillSelectionDialog"
			@onSave="handleSelectedSkills($event)"
			:skills="skillData"
		/>
		<skill-level-selector-dialog
			ref="skillLevelSelectionDialog"
			:skill="focusedSkill"
			@onLevelSelected="handleSkillLevelSelection($event)"
		/>
	</div>
</template>

<script>
import cTitleHeader from '@/modules/job-profile/components/content/c-title-header';
import modelStepper from '@/modules/job-profile/components/content/model-stepper';
import PCard from '@/modules/shared/components/ui/Card/p-card';
import PEmptyMessage from '@/modules/shared/components/ui/p-empty-message';
import PButton from '@/modules/shared/components/ui/p-button';
import PHorizontalDivider from '@/modules/shared/components/ui/p-horizontal-divider';
import modelDescription from '@/modules/job-profile/components/content/model-description';
import SkillSelectionDialog from '@/modules/job-profile/components/fifth-step/skill-selection-dialog';
import SkillLevelSelectorDialog from '@/modules/job-profile/components/fifth-step/skill-level-selector-dialog';
import SkillItem from '@/modules/job-profile/components/fifth-step/skill-item';
import helper from '@/shared/helper';
import { mapState } from 'vuex';
import { pathOr } from 'ramda';
import { transformSkillData } from '@/modules/three-sixty-evaluation/utils';

const { getLocalData } = helper;

function created() {}

async function loadData() {
	const response = await this.getDataStep('E360');
	this.skillData = transformSkillData(response);
	try {
		const { data: responses } = await this.$httpPraktiko.get(`job-description/detail/${this.codeStep.code}/${this.selectedJob.id}`);
		if (Object.keys(response).length !== 0) {
			this.selectedSkills = responses.description;
		}
	} catch (error) {
		this.showGenericError();
	}
	this.validate = this.selectedSkills.some(item => !item.selectedLevel);
}

async function getDataStep(typeKey) {
	const { data } = await this.$http.get(`/hierarchies/${typeKey}`);
	return data;
}

function loadCodeStep(obj) {
	this.codeStep = obj;
}

function choosenSkills() {
	this.$refs.skillSelectionDialog.open();
}

function handleSelectedSkills(selectedSkills) {
	this.selectedSkills = selectedSkills;
	this.selectedSkills = this.selectedSkills.map((skill) => {
		const newLevels = skill.levels.map((level) => {
			const { questions, ...levelWithoutQuestions } = level;
			return levelWithoutQuestions;
		});
		return {
			...skill,
			levels: newLevels,
		};
	});
	this.$refs.skillSelectionDialog.close();
	this.validate = this.selectedSkills.some(item => !item.selectedLevel);
}

function handleChooseLevelSkillItem(skillItem) {
	this.focusedSkill = skillItem;
	this.$refs.skillLevelSelectionDialog.open();
}

function handleRemoveSkillItem(skillItem) {
	this.selectedSkills = this.selectedSkills.filter(element => element.id !== skillItem.id);
	this.validate = this.selectedSkills.some(item => !item.selectedLevel);
}


function handleSkillLevelSelection(skillLevelSelected) {
	const dataWithoutQuestions = skillLevelSelected;
	delete dataWithoutQuestions.questions;
	this.focusedSkill = {
		...this.focusedSkill,
		selectedLevel: dataWithoutQuestions,
		questionsType: undefined,
	};
	const { questions, ...focusedSkillWithoutQuestions } = this.focusedSkill;
	this.focusedSkill = focusedSkillWithoutQuestions;
	this.selectedSkills = this.selectedSkills.map((skl) => {
		if (skl.id === this.focusedSkill.id) {
			return { ...this.focusedSkill };
		}
		return skl;
	});
	this.validate = this.selectedSkills.some(item => !item.selectedLevel);
}

async function saveStepFifth() {
	const body = {
		description: this.selectedSkills,
		typeDescriptionCode: this.codeStep.code,
		jobId: this.selectedJob.id,
	};
	try {
		await this.$httpPraktiko.post('job-description', body);
		this.showNotification('Destrezas Requeridas Guardadas Exitosamente');
		this.goTo(this.codeStep.goTo);
	} catch (error) {
		this.showGenericError();
	}
}

export default {
	name: 'job-required-skills',
	created,
	mounted() {},
	data() {
		return {
			codeStep: {},
			skillData: [],
			selectedSkills: [],
			focusedSkill: {},
			validate: true,
		};
	},
	components: {
		cTitleHeader,
		modelStepper,
		PCard,
		PEmptyMessage,
		PButton,
		PHorizontalDivider,
		modelDescription,
		SkillSelectionDialog,
		SkillLevelSelectorDialog,
		SkillItem,
	},
	methods: {
		loadData,
		loadCodeStep,
		getDataStep,
		choosenSkills,
		handleSelectedSkills,
		handleChooseLevelSkillItem,
		handleRemoveSkillItem,
		handleSkillLevelSelection,
		saveStepFifth,
	},
	computed: {
		...mapState('jobProfile', {
			selectedJob(state) {
				return pathOr(getLocalData('selectedJob'), ['selectedJob'], state.jobProfile) || [];
			},
			// pathOr([], ['selectedJob']) || getLocalData('selectedJob'),
		}),
	},
	watch: {
		codeStep: {
			handler(newVal) {
				this.codeStep = newVal;
				this.loadData();
			},
		},
	},
};
</script>

<style lang="scss" scoped>
.competences {
	&-header {
		background-color: var(--app-color-primary);
		border-radius: 5px;
		span {
			color: white !important;
			font-weight: bold;
		}
	}
	&-list {
		overflow: auto;
		height: 40vh;
		color: color(gray-sidebar) !important;
	}
}
.content-box {
	border: 1px solid color(border-gray);
	background-color: color(gray-light);
	border-radius: 5px;
	height: auto;
	width: 100%;
	padding: 10px;
	table {
		width: 100%;
		// border-collapse: collapse;
		text-align: left;
		font-size: 12px;
	}
}
</style>


// WEBPACK FOOTER //
// src/modules/job-profile/pages/fifth-page/job-required-skills.vue